import React from "react";
import DobbyChatFloating from "./DobbyChatFloating";
import { apiClient } from "../../utils/apiClient";

// Wrapper component for www application with email modal support
interface DobbyChatWrapperProps {
  conversationType: "example" | "rule_update" | "shipment_question";
  initialMessage?: string;
  ruleId?: string;
  extraParams?: {
    feedId?: string;
  };
  onConversationEnd?: (result: string | null) => void;
  // Optional: Component for displaying email threads in modal
  EmailThreadComponent?: React.ComponentType<{
    emailId: string;
    sx?: any;
  }>;
  // Optional: Callback to scroll to an email in the timeline (instead of opening modal)
  onScrollToEmail?: (emailId: string) => void;
}

const DobbyChatWrapper: React.FC<DobbyChatWrapperProps> = (props) => {
  return (
    <DobbyChatFloating
      {...props}
      apiClient={apiClient}
      avatarImagePath="/www/assets/dobby_internal_tools_icon.png"
    />
  );
};

export default DobbyChatWrapper;
